import * as Yup from "yup";
import { REGEX } from "../../../../utils/constants";
/**
 * @description declaration form schema for client validations
 */
export const changePasswordSchema = Yup.object().shape({
    oldPassword: Yup.string()
    .required("Old password field is required"),
    // password: Yup.string()
    //   .matches(/^\S*$/, 'Space is not allowed')
    //   .min(8, "Password must be atleast 8 characters long")
    //   .max(50, "Maximum 50 symbols")
    //   .required("Password field is required")
    //   .matches(REGEX.PASSWORD,
    //     'Password must contain at least one alphabet, one special character and one numeric value'),
    password: Yup
    .string()
    .required('Please Enter your password')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    ),

    confirmPassword: Yup.string()
    .required("Confirm password field is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
 
});



/**
 * @description params intilaization 
 */

export const changePasswordInit = {
    oldPassword: '',
    password: '',
    confirmPassword:''
}